import React from "react";
import type { SlackConnectionStatusProps } from "./SlackConnectionStatus.types";
import {
  StatusRow,
  StatusText,
  ConnectedBadge,
  ConnectButton,
  ErrorText,
} from "./SlackConnectionStatus.styles";

/**
 * Stateless not-connected/connected row shown above the Slack destination
 * picker in the Share flow. All state (status query, popup lifecycle) is
 * owned by the organism via `useSlackConnection` — this only renders props.
 */
export const SlackConnectionStatus: React.FC<SlackConnectionStatusProps> = ({
  isConnected,
  isStatusLoading,
  connecting,
  connectError,
  onConnect,
  disconnecting,
  onDisconnect,
}) => {
  if (isStatusLoading) {
    return (
      <StatusRow>
        <StatusText>Checking Slack connection…</StatusText>
      </StatusRow>
    );
  }

  if (isConnected) {
    return (
      <StatusRow>
        <ConnectedBadge>● Slack connected</ConnectedBadge>
        {onDisconnect && (
          <ConnectButton type="button" onClick={onDisconnect} disabled={disconnecting}>
            {disconnecting ? "Disconnecting…" : "Disconnect"}
          </ConnectButton>
        )}
      </StatusRow>
    );
  }

  return (
    <StatusRow>
      <StatusText>Slack isn&apos;t connected yet</StatusText>
      <div>
        <ConnectButton type="button" onClick={onConnect} disabled={connecting}>
          {/* "Add Slack" not "Sign in with Slack" — this action installs/
              authorizes the app into a workspace, not just a login. */}
          {connecting ? "Connecting…" : "Add Slack"}
        </ConnectButton>
        {connectError && <ErrorText>{connectError}</ErrorText>}
      </div>
    </StatusRow>
  );
};

export default SlackConnectionStatus;
